import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
  select
} from "redux-saga/effects";
import BotService from "../../services/Bots";

import {
  Types,
  botList,
  botListSuccess,
  botModalVisible,
  setBotQueryParams
} from "../reducers/Bot";

import { componentLoading, buttonLoading } from "../actions/loading";
import { notificationMessage } from "../reducers/FeedbackMessage";

const getBotState = state => state.bot;


const listAllBotsRequest = async (id, queryParams) =>
  await BotService.list(id, queryParams)
    .then(bots => bots)
    .catch(error => {
      throw error;
    });

const createBotRequest = async payload =>
  await BotService.create(payload)
    .then(bot => bot)
    .catch(error => {
      throw error;
    });

const deleteBotRequest = async payload =>
  await BotService.remove(payload)
    .then(bot => bot)
    .catch(error => {
      throw error;
    });

const updateBotRequest = async payload =>
  await BotService.update(payload)
    .then(bot => bot)
    .catch(error => {
      throw error;
    });

function* listAllBotsWithCompanyId({ payload: { id, queryParams } }) {
  try {
    yield put(componentLoading(true));
    yield put(setBotQueryParams(queryParams || {}));
    const bots = yield call(listAllBotsRequest, id, queryParams);
    yield put(componentLoading(false));
    yield put(botListSuccess(bots));
  } catch (error) {
    yield put(componentLoading(false));
    yield put(notificationMessage("notifications.bot.list.error", "error"));
  }
}

function* refreshBotsWithLastQueryParams() {
  const botState = yield select(getBotState);
  yield put(botList(undefined, botState.lastQueryParams || {}));
}

function* createBot({ payload }) {
  try {
    yield put(buttonLoading(true));
    yield call(createBotRequest, payload);
    yield put(buttonLoading(false));
    yield put(botModalVisible(false, true));
    yield put(
      notificationMessage("notifications.bot.create.success", "success")
    );
    try {
      yield call(refreshBotsWithLastQueryParams);
    } catch (err) {
      yield put(notificationMessage("notifications.bot.list.error", "error"));
    }
  } catch (error) {
    yield put(buttonLoading(false));
    yield put(notificationMessage("notifications.bot.create.error", "error"));
  }
}

function* deleteBot({ payload }) {
  yield put(buttonLoading(true));
  try {
    yield call(deleteBotRequest, payload);
    yield put(buttonLoading(false));
    yield put(botModalVisible(false, true));
    yield put(
      notificationMessage("notifications.bot.delete.success", "success")
    );
    try {
      yield call(refreshBotsWithLastQueryParams);
    } catch (err) {
      yield put(notificationMessage("notifications.bot.list.error", "error"));
    }
  } catch (error) {
    yield put(buttonLoading(false));
    yield put(botModalVisible(false, true));
    yield put(notificationMessage("notifications.bot.delete.error", "error"));
  }
}

function* updateBot({ payload }) {
  yield put(buttonLoading(true));
  try {
    yield call(updateBotRequest, payload);
    yield put(buttonLoading(false));
    yield put(botModalVisible(false, true));
    yield put(
      notificationMessage("notifications.bot.update.success", "success")
    );
    try {
      yield call(refreshBotsWithLastQueryParams);
    } catch (err) {
      yield put(notificationMessage("notifications.bot.list.error", "error"));
    }
  } catch (error) {
    yield put(buttonLoading(false));
    yield put(notificationMessage("notifications.bot.update.error", "error"));
  }
}

export function* botListSaga() {
  yield takeLatest(Types.BOT_LIST, listAllBotsWithCompanyId);
}

export function* botCreateSaga() {
  yield takeEvery(Types.BOT_CREATE, createBot);
}

export function* botDeleteSaga() {
  yield takeEvery(Types.BOT_DELETE, deleteBot);
}

export function* botUpdateSaga() {
  yield takeEvery(Types.BOT_UPDATE, updateBot);
}

// export function* botSetQueryParams() {
//     yield takeLatest(Types.SET_BOT_QUERY_PARAMS, listAllBotsWithCompanyId);
// }

export default function* rootSaga() {
  yield all([
    fork(botListSaga),
    fork(botCreateSaga),
    fork(botDeleteSaga),
    fork(botUpdateSaga)
    // fork(botSetQueryParams)
  ]);
}
